import React from "react";
import { cn } from "@/lib/utils";

const MAP = {
  paid: "bg-emerald-100 text-emerald-700 border-emerald-200",
  unpaid: "bg-rose-100 text-rose-700 border-rose-200",
  partial: "bg-amber-100 text-amber-700 border-amber-200",
  draft: "bg-slate-100 text-slate-600 border-slate-200",
  cancelled: "bg-slate-200 text-slate-500 border-slate-300 line-through",
  overdue: "bg-rose-100 text-rose-700 border-rose-200",
};

const LABEL = {
  paid: "Paid", unpaid: "Unpaid", partial: "Partial",
  draft: "Draft", cancelled: "Cancelled", overdue: "Overdue",
};

export default function StatusBadge({ status, overdue }) {
  const key = overdue && (status === "unpaid" || status === "partial") ? "overdue" : status;
  return (
    <span
      data-testid={`status-${key}`}
      className={cn("inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border capitalize",
        MAP[key] || MAP.draft)}
    >
      {LABEL[key] || status}
    </span>
  );
}
